import {
  AutoBonusPaymentResponse,
  AutoBonusPaymentsPageResponse,
} from "../../../domain/models/integration/auto-bonus-payments.model";

type UnknownRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);
const isString = (value: unknown): value is string => typeof value === "string";
const isNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);

const isPayment = (value: unknown): value is AutoBonusPaymentResponse =>
  isRecord(value) &&
  isString(value["scheduleId"]) &&
  isString(value["username"]) &&
  isString(value["memberFullName"]) &&
  isNumber(value["amountToPay"]) &&
  isNumber(value["rankId"]) &&
  isString(value["carType"]) &&
  isString(value["paymentDate"]) &&
  (value["status"] === "PENDING" || value["status"] === "PAID") &&
  isString(value["currency"]) &&
  isString(value["registrationDate"]) &&
  isString(value["paymentSource"]) &&
  isString(value["concept"]) &&
  (value["receiptUrl"] === null || isString(value["receiptUrl"]));

export function isAutoBonusPaymentsPageResponse(
  value: unknown,
): value is AutoBonusPaymentsPageResponse {
  return isRecord(value) &&
    Array.isArray(value["content"]) &&
    value["content"].every(isPayment) &&
    isNumber(value["page"]) &&
    isNumber(value["size"]) &&
    isNumber(value["totalElements"]) &&
    isNumber(value["totalPages"]);
}
